module.exports = __webpack_public_path__ + "static/media/device_privatization_en.80b97804.md";